export const ultimasNoticias = [
    /*
        "imagen" : "/assets/imgs/Noticias/Capacitacionre.png",
        "url" : "https://forms.gle/XseXY4L5PXzPRPgw8",
        "titulo" : "“Educación vial y manejo defensivo para las personas operadoras del transporte público”",
        "fecha" : "Pre-registrate al curso de capacitación"        
    */
    
    {
        "imagen" : "/assets/imgs/Noticias/Noticias1.png",
    //    "url" : "https://quejas.transportehidalgo.gob.mx/",
        "titulo" : "¿Tienes alguna queja del transporte público?",
        "fecha" : "Llama al 800-503-2002 o al 771-526-1284 quejatransporte@hidalgo.gob.mx"        
    }
    ,
        {
        "imagen" : "/assets/imgs/Noticias/Banner.png",
        "url" : "https://sep.hidalgo.gob.mx/index.php?ruta=convocatorias/progViolencia-mujeres",
        "titulo" : "PROGRAMA INTEGRAL ",
        "fecha" : "“PREVENIR, ATENDER, SANCIONAR Y ERRADICAR LA VIOLENCIA CONTRA LAS MUJERES PIPASEVM (2019-2024)”"        
    }
    ,
    {
        "imagen" : "/assets/imgs/Noticias/Acoso.png",    
        "url" : "https://www.gob.mx/cms/uploads/attachment/file/765398/Cuadernillo_Personas_Conductoras_V2.pdf",
        "titulo" : "El acoso sexual en el transporte público",
        "fecha" : "Conductas, prácticas y diversas manifestaciones de connotación sexual"        
    }
    
    ,
    {
        "imagen" : "/assets/imgs/Noticias/Conseciones.png",
        "titulo" : "¡No te dejes sorprender!",
        "fecha" : "Las concesiones de transporte público son otorgadas por Gobierno del Estado"        
    }
]